import React, { useEffect, useState } from 'react'
import { Dialog, Button } from '@material-ui/core'

function ConfirmationDialog(props) {
    const [title, setTitle] = useState('')
    const [message, setMessage] = useState('')

    useEffect(() => {
        setTitle(props.title)
        setMessage(props.message)
    }, [])

    const onCloseScreen = () => {
        props.onCloseFunc()
    }

    return (
        <Dialog open={true} onClose={onCloseScreen} maxWidth="sm" fullWidth aria-labelledby="confirmationDialog">
            <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 24, paddingRight: 16, paddingLeft: 16, paddingBottom: 8 }}>
                <p className="PrimaryText" style={{color: 'white'}}>{title}</p>
                <p className="ThirdLightText" style={{ color: '#eeeeee', marginLeft: 16, marginTop: 6 }}>
                    {message}
                </p>
                <div style={{ display: 'flex', height: 40, alignItems: 'center', textAlign: 'left', direction: 'ltr', marginTop: 12 }}>
                    <Button onClick={() => props.onCloseFunc()} >
                        انصراف
                    </Button>
                    <Button onClick={() => props.ok()} style={{ marginRight: 8, color: 'white' }}>
                        انجام
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}

export default ConfirmationDialog
